import { UserFavorites } from "./UsersFavorites";
export default UserFavorites;
